import script from "./PropertyDetailCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyDetailCard.vue?vue&type=script&setup=true&lang=js"

import "./PropertyDetailCard.vue?vue&type=style&index=0&id=eafb0462&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eafb0462"]])

export default __exports__